import React, { useState } from "react";
import { Request } from "../../api/auth/Password.api";
import ResetConfirmPasswordView from "../../views/auth/ResetConfirmPasswordView";
import Error from "../../components/Error";
import Success from "../../components/Success";
import Loading from "../../components/Loading";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

const initialValues = {
  password: "",
  confirm_password: "",
};

const ResetConfirmPasswordContainer = ({ uid, token, type, message }) => {
  const { t } = useTranslation();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const history = useHistory();

  const onSubmit = (values, actions) => {
    setSuccess(null);
    setError(null);
    setLoading(true);
    Request.resetConfirmPassword({ ...values, uid: uid, token: token })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    setSuccess(true);
    actions.setSubmitting(false);
    setLoading(false);
  };

  const onFailure = (error, actions) => {
    if (error.message === "password_mismatch" || "user_password_mismatch") {
      setError({ message: t("reset_confirm.errors.password_mismatch") });
    } else if (error.message === "wrong_password") {
      setError({ message: t("reset_confirm.errors.wrong_password") });
    } else {
      setError(error);
    }
    setLoading(false);
    actions.setSubmitting(false);
  };

  const redirect = () => {
    setSuccess(null);
    history.push("/login/" + type);
  };

  return (
    <>
      {success ? (
        <Success message={message} onClose={() => redirect()} />
      ) : null}
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      <ResetConfirmPasswordView
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
    </>
  );
};

export default ResetConfirmPasswordContainer;
